import React from "react";
import { useTagAndSegment } from "../../contexts/tagAndSegment";

const SegmentBuilderConditionsAndBlock = ({ children, node }) => {
  const { handleAddAnd } = useTagAndSegment();

  return (
    <div className="flex flex-col items-start my-4 border-4 p-6 rounded-xl w-full">
      {children}
      <button onClick={() => handleAddAnd(node.id)} className="text-blue-500">
        + Add "and"
      </button>
    </div>
  );
};

export default SegmentBuilderConditionsAndBlock;
